import React, { useCallback } from 'react';

import CompetencyPeriodSelect from 'components/MeshList/levelUp/competencyScreen/CompetencyPeriodSelect';
import { VerticallyAlignedFlexContainer } from 'styles/common';

import theme from 'constants/theme';

import { Typography12, Typography14 } from 'uiToolkit/Typography';

import useLevelUpSidePanelContext from '../context';

const Details = ({ source = '' }) => {
  const {
    state: { levelUpCompetencyDetails, levelUpTargetDates },
    handleCompetencyTargetDateChange,
  } = useLevelUpSidePanelContext();

  const {
    competencyId,
    jobFunction,
    jobRole,
    status,
    targetDate,
    progressBar,
    competencyStatus,
    activity,
    targetDate: targetPeriodStart,
    accessible,
  } = levelUpCompetencyDetails;

  const handleTargetDateChange = useCallback(
    ({ competencyId, targetPeriodStart: newTargetPeriodStart, subComptencyId = null }) => {
      handleCompetencyTargetDateChange({
        jobFunctionId: jobFunction.uuid,
        jobRoleId: jobRole.uuid,
        competencyId,
        targetPeriodStart: newTargetPeriodStart,
        subComptencyId,
      });
    },
    [jobFunction, jobRole, handleCompetencyTargetDateChange]
  );
  return (
    <div>
      <Typography14 weight={600} color={theme.palette.text.blackv1}>
        Details
      </Typography14>
      <Typography12 topGutter={3} color={theme.palette.text.label}>
        {levelUpCompetencyDetails?.competencyDescription ?? ''}
      </Typography12>

      {accessible && (
        <VerticallyAlignedFlexContainer style={{ marginTop: '1.5rem' }}>
          <Typography12 weight={600} rightGutter={2} color={theme.palette.text.label}>
            Target
          </Typography12>
          <CompetencyPeriodSelect
            competencyId={competencyId}
            selectedPeriod={targetPeriodStart}
            handleTargetDateChange={handleTargetDateChange}
            levelUpTargetDates={levelUpTargetDates}
          />
        </VerticallyAlignedFlexContainer>
      )}
    </div>
  );
};

export default Details;
